import React from 'react';
import { Link } from 'react-router-dom';

const onboardingSteps = [
  {
    id: 'create-org',
    step: 1,
    title: 'Create organization',
    description: 'Set up your workspace',
  },
  {
    id: 'connect-ga4',
    step: 2,
    title: 'Connect Google Analytics 4',
    description: 'Link your GA4 property to start analyzing your data',
  },
  {
    id: 'first-thread',
    step: 3,
    title: 'Run an AI Agent',
    description: 'Choose from specialized agents that analyze your data autonomously',
    tip: 'Need inspiration? Browse the',
    tipLink: '/prompt-library',
    tipLinkText: 'Prompt Library',
  },
  {
    id: 'schedule-report',
    step: 4,
    title: 'Schedule a report',
    description: 'Set up automated insights delivery to your inbox',
  },
  {
    id: 'invite-team',
    step: 5,
    title: 'Invite team members',
    description: 'Collaborate with your team on analytics insights',
  },
];

/**
 * GettingStarted Component
 * Renders a stepper guide for onboarding users
 */
const GettingStarted = () => {
  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="px-6 py-5 border-b border-gray-100">
        <div>
          <h2 className="text-sm text-gray-500">
            Quickstart Guide
          </h2>
          <p className="text-xs text-gray-400">
            Get the most out of GA4.so
          </p>
        </div>
      </div>

      {/* Steps */}
      <div className="flex-1 p-6 overflow-y-auto">
        <div className="space-y-1">
          {onboardingSteps.map((step, index) => {
            const isLast = index === onboardingSteps.length - 1;

            return (
              <div key={step.id} className="relative">
                {/* Vertical connector */}
                {!isLast && (
                  <div className="absolute left-[23px] top-[36px] w-px h-[calc(100%-12px)] bg-gray-200" />
                )}

                <div className="flex gap-3 p-3 rounded-lg hover:bg-white transition-colors group">
                  {/* Step number */}
                  <div className="relative z-10 flex-shrink-0 w-6 h-6 rounded-full bg-[#CC457D]/10 text-[#CC457D] flex items-center justify-center text-xs font-medium">
                    {step.step}
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-medium text-gray-900 group-hover:text-brand-pink transition-colors">
                      {step.title}
                    </h3>
                    <p className="text-xs text-gray-500 mt-0.5 leading-relaxed">
                      {step.description}
                    </p>

                    {step.tip && (
                      <div className="mt-1.5 flex items-center gap-1 text-xs text-gray-500">
                        <span>{step.tip}</span>
                        <Link to={step.tipLink} className="font-medium text-brand-pink hover:underline">
                          {step.tipLinkText}
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default GettingStarted;
